import { QueryMany } from "../types";

export const defineQuery = (query: QueryMany<unknown>): QueryMany<unknown> => {
  return query;
};
